/**
 * Checks if the passed argument is Undefined or Null
 * and returns the result
 */

// isNil :: a -> Boolean
function isNil(x: unknown): x is undefined | null {
  return x === undefined || x === null;
}

export default isNil;
